const initialize=(root)=>{if(root.dataset.fp5Ready)return;root.dataset.fp5Ready='true';const cleanups=[];
// Every card has a reviewed alternate photograph or fixed detail crop.
const previewObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>{
 entries.forEach(entry=>{if(entry.isIntersecting){loadPreview(entry.target);previewObserver.unobserve(entry.target)}});
},{rootMargin:'240px'}) : null;
function loadPreview(link){
 const img=link.querySelector('[data-secondary-src]');
 if(!img||img.dataset.requested)return;
 img.dataset.requested='true';img.src=img.dataset.secondarySrc;
 img.decode().then(()=>link.classList.add('fp5-preview-ready')).catch(()=>{link.classList.add('fp5-preview-unavailable');img.removeAttribute('src')});
}
function preparePreviews(root){
 root.querySelectorAll('.fp5-product-photo:has([data-secondary-src])').forEach(link=>{
  if(link.dataset.previewBound)return;
  link.dataset.previewBound='true';link.classList.add('fp5-has-preview');
  link.addEventListener('pointerenter',()=>loadPreview(link),{once:true});
  link.addEventListener('focus',()=>loadPreview(link),{once:true});
  if(previewObserver)previewObserver.observe(link);else loadPreview(link);
 });
}
preparePreviews(root);
const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
root.querySelectorAll('.fp5-shelf').forEach(shelf=>{
 const rail=shelf.querySelector('.fp5-rail');if(!rail)return;
 const previous=shelf.querySelector('[data-direction="-1"]'),next=shelf.querySelector('[data-direction="1"]');
 const update=()=>{const controls=shelf.querySelector('.fp5-rail-controls');if(controls)controls.hidden=rail.scrollWidth<=rail.clientWidth+3;if(previous)previous.disabled=rail.scrollLeft<3;if(next)next.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-3};
 const advance=direction=>{
  const cards=[...rail.children],gap=parseFloat(getComputedStyle(rail).columnGap)||0;
  if(!cards.length)return;
  const step=cards[0].getBoundingClientRect().width+gap;
  const count=Math.max(1,Math.round(rail.clientWidth/step));
  const current=Math.round(rail.scrollLeft/step);
  rail.scrollTo({left:Math.max(0,(current+direction*count)*step),behavior:reduceMotion?'instant':'smooth'});
 };
 shelf.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>advance(Number(button.dataset.direction))));
 rail.addEventListener('scroll',update,{passive:true});rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();advance(event.key==='ArrowRight'?1:-1)}});
 const observer=new ResizeObserver(update);observer.observe(rail);cleanups.push(()=>observer.disconnect());shelf.updateRail=update;update();
});
const arrivals=root.querySelector('.fp5-just-in');
arrivals?.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
 const filter=button.dataset.filter;
 const template=arrivals.querySelector(`template[data-arrivals="${filter}"]`);
 if(!template)return;
 const rail=arrivals.querySelector('.fp5-rail');
 if(previewObserver)rail.querySelectorAll('.fp5-has-preview').forEach(link=>previewObserver.unobserve(link));
 rail.replaceChildren(template.content.cloneNode(true));
 preparePreviews(rail);
 rail.scrollTo({left:0,behavior:'instant'});
 rail.setAttribute('aria-label',`Just In: ${filter==='All'?'All departments':filter}`);
 arrivals.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 const shown=rail.querySelectorAll('.fp5-product').length;
 arrivals.querySelector('.fp5-filter-status').textContent=`${shown} ${filter==='All'?'new arrivals':filter+' products'} shown.`;
 arrivals.querySelector('.fp5-shelf').updateRail();
 requestAnimationFrame(()=>arrivals.querySelector('.fp5-shelf').updateRail());
}));

const hero=root.querySelector('.fp5-hero');if(hero){
 const headerSections=[...document.querySelectorAll('#header-group > .shopify-section')];
 const updateHero=()=>{
  // The shared header group uses display:contents; measure its visible sections.
  const headerHeight=headerSections.reduce((height,section)=>height+section.getBoundingClientRect().height,0);
  root.style.setProperty('--fp5-header-height',`${headerHeight}px`);
  const bar=document.querySelector('#PBarNextFrameWrapper');
  root.style.setProperty('--fp5-preview-height',`${bar?.getBoundingClientRect().height||0}px`);
 };
 updateHero();const observer=new ResizeObserver(updateHero);
 headerSections.forEach(section=>observer.observe(section));
 window.addEventListener('resize',updateHero);
 cleanups.push(()=>{observer.disconnect();window.removeEventListener('resize',updateHero)});
}
root.fp5Cleanup=()=>{previewObserver?.disconnect();cleanups.forEach(fn=>fn())};
};
const boot=(scope=document)=>scope.querySelectorAll('[data-fp-v5]').forEach(initialize);
boot();document.addEventListener('shopify:section:load',event=>boot(event.target));document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fp-v5]').forEach(root=>root.fp5Cleanup?.()));
